import React from 'react';
import './loader.scss';

export default function ProgressBar() {
  return (
    <div className="progress-container">
      <div className="progress-bar" />
    </div>
  );
}
